export default "__VITE_ASSET__QaxHGqaT__"